export default "__VITE_ASSET__QqK$867I__"